import { useRef } from "react";
import { gsap, isCoarsePointer, prefersReducedMotion } from "@/lib/motion";

/**
 * A hairline cell that lifts off the page on hover. Deliberately restrained:
 * ~5deg and a warm, paper-toned shadow, so it reads as a sheet of card being
 * picked up rather than a glassy web card. Keeps the 0px-radius rule intact.
 */
export default function DepthCard({ children, className = "", intensity = 5 }) {
  const outer = useRef(null);
  const inner = useRef(null);
  const enabled = !isCoarsePointer() && !prefersReducedMotion();

  const onMove = (e) => {
    if (!enabled || !outer.current) return;
    const r = outer.current.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    gsap.to(inner.current, {
      rotateY: px * intensity,
      rotateX: -py * intensity,
      z: 24,
      duration: 0.5,
      ease: "power3.out",
      transformPerspective: 900,
    });
  };

  const onLeave = () => {
    if (!enabled || !inner.current) return;
    gsap.to(inner.current, { rotateY: 0, rotateX: 0, z: 0, duration: 0.7, ease: "power3.out" });
  };

  return (
    <div
      ref={outer}
      className={className}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      style={{ perspective: 900 }}
    >
      <div ref={inner} className="depth-card h-full" style={{ transformStyle: "preserve-3d" }}>
        {children}
      </div>
    </div>
  );
}
